
export const isDevMode = !process.env.NODE_ENV || process.env.NODE_ENV === "development";

export const isProdMode = !isDevMode;